<template>
  <div class="content">
    <h2 class="pl-3">{{ father }} | Notas Materia</h2>

    <v-dialog v-model="dialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">Atención...!!!</v-card-title>
        <v-card-text>No puede ingresar una nota superior a '10.00'</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="dialog = false"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row align="center" justify="center">
      <v-col md="auto" class="input">
        <v-select
          v-model="cursoSeleccionado"
          ref="cursoList"
          :items="cursos"
          item-text="descripcion"
          item-value="id"
          label="Cursos"
          @change="obtenerMateriasDeCurso()"
        ></v-select>
      </v-col>
      <v-col md="auto" v-if="cursoSeleccionado != ''" class="input">
        <v-select
          v-model="materiaAgrupamiento"
          ref="materiaList"
          :items="materias"
          item-text="materia"
          item-value="id"
          label="Materia"
          @change="obtenerNotasDeMateria()"
        ></v-select>
      </v-col>
    </v-row>

    <template v-if="mostrarNotas" class="estiloTexto">
      <div class="estiloTexto">
        <v-row no-gutters>
          <v-col cols="2" class="text-center colorHeaders"></v-col>
          <v-col cols="9">
            <v-row no-gutters>
              <v-col
                v-for="termino in headers"
                :key="termino.grupoID"
                class="text-center colorHeaders"
                v-bind:class="[
                  termino.descripcion_grupo == 'examenes'
                    ? 'ocultarHeader'
                    : '',
                ]"
                >{{ mayusculas(termino.descripcion_grupo) }}</v-col
              >
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="2" class="text-center colorHeaders"
            >Apellido(s) y Nombre(s)</v-col
          >
          <v-col cols="9">
            <v-row no-gutters>
              <v-col
                cols="3"
                v-for="grupo in headers"
                :key="grupo.grupoID"
                class="borde-grupo-notas"
              >
                <v-row justify-center no-gutters>
                  <v-col
                    cols="4"
                    v-if="grupo.descripcion_grupo == 'examenes'"
                    class="text-xs-center font_size_11px"
                    >Promedio Anual</v-col
                  >
                  <v-col
                    v-bind:class="[
                      grupo.descripcion_grupo == 'examenes' ? 'xs4' : 'xs2',
                    ]"
                    v-for="item in grupo.notas"
                    :key="item.id"
                    class="text-center font_size_11px"
                    >{{ item.descripcion_nota }}</v-col
                  >
                  <v-col
                    cols="2"
                    class="text-center textoCentrado font_size_11px"
                    v-if="grupo.verPromedio != '0'"
                    >Prom</v-col
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" class="text-center font_size_11px"
            >Calicación Definitiva</v-col
          >
        </v-row>
        <v-row v-if="alumnos.length > 0" no-gutters>
          <v-col cols="12">
            <template v-for="alumno in alumnos">
              <alumno
                :key="alumno.idAlumno"
                :idalumno="alumno.idAlumno"
                :nota_consolidada="alumno.nota_final"
                :nombreAlumno="alumno.nombre_alumno"
                :apellidoAlumno="alumno.apellido_alumno"
                :gruposNotas="alumno.grupos"
                :materia="materiaAgrupamiento"
                :alumnoRegular="alumno.regular"
                :permisoEdicion="permisoEdicionNotas"
                :habilitarEdicion="permisoEdicionNotas"
                @itemAlumno:recargarNotas="recargarNotas"
                @itemAlumno:mostrarMsjNotaInvalida="mostrarMsjNotaInvalida"
              />
            </template>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-else-if="msjError != ''">
      <v-row align="center" justify="center" no-gutters>
        <v-col md="auto">
          {{ msjError }}
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import alumno from "@/components/docentes/itemAlumno";

export default {
  data() {
    return {
      dialog: false,
      materiaAgrupamiento: "",
      cursoSeleccionado: "",
      mostrarNotas: false,
      cursos: [],
      materias: [],
      alumnos: [],
      permisoEdicionNotas: false,
      msjError: "",
    };
  },
  props: ["father"],
  components: {
    alumno,
  },
  mounted: function () {
    let local = window.localStorage.getItem("EPA_AUTH");

    if (local != null) {
      let localJson = JSON.parse(local);
      let idCategoriaUsuario = localJson.idCategoria;

      if (idCategoriaUsuario < 3) this.permisoEdicionNotas = true;
      //header = { Authentication: "Bearer " + token };
    }

    let resultado = API.enviar("get", "obtenerCursos", "");

    resultado
      .then((result) => {
        //console.log(result);
        if (result.data.msj == "ok") this.cursos = result.data.result;
        //this.materiasCant = result.data.length;
      })
      .catch(() => {
        //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
      });
  },
  methods: {
    mayusculas: function (string) {
      let string_aux = API.ucFirst(string);
      return string_aux;
    },
    obtenerHeaders: function () {
      let headersGrupos = [];
      let primerAlumno = this.alumnos[0];

      for (const obj in primerAlumno.grupos) {
        headersGrupos.push(primerAlumno.grupos[obj]);
      }

      this.headers = headersGrupos;
    },
    recargarNotas: function () {
      this.obtenerNotasDeMateria(this.materiaAgrupamiento);
    },
    mostrarMsjNotaInvalida: function () {
      this.dialog = true;
      this.recargarNotas();
    },
    obtenerMateriasDeCurso: function () {
      //console.log("obtenerMateriasCurso", this.cursoSeleccionado);
      this.mostrarNotas = false;
      let params = "curso=" + this.cursoSeleccionado;
      let resultado = API.enviar("get", "obtenerMateriasCurso", params);

      resultado
        .then((result) => {
          //console.log(result);
          if (result.data.msj == "ok") this.materias = result.data.result;
          //this.materiasCant = result.data.length;
        })
        .catch(() => {
          //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
        });
    },
    obtenerNotasDeMateria: function () {
      this.$emit("notasMaterias:mostrarOcultarPreload");

      let params = "idMateria=" + this.materiaAgrupamiento;
      let resultado = API.enviar("get", "obtenerNotasMateria", params);

      resultado
        .then((result) => {
          if (result.data.msj == "ok") {
            this.alumnos = result.data.result;
            this.mostrarNotas = true;
            this.obtenerHeaders();
            //console.log(this.alumnos.length);
          } else {
            this.mostrarNotas = false;
            this.msjError = result.data.msj;
          }
        })
        .catch(() => {
          //console.log("catch obtenerNotasMateria");
        })
        .finally(() => {
          this.$emit("notasMaterias:mostrarOcultarPreload");
        });
    },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
}

h2 {
  padding-bottom: 20px;
}

.input {
  padding: 5px;
}

.colorHeaders {
  color: #fff;
  font-weight: bold;
  background-color: #4caf50;
  opacity: 0.7;
  margin: 2px;

  /*padding-left: 5px;*/
}
.borde-grupo-notas {
  border-right: solid 2px rgba(76, 174, 79, 0.7);
}

.estiloTexto {
  font-size: 12px;
  text-align: left;
}

.ocultarHeader {
  visibility: hidden;
}

input {
  background: #fff !important;
}
</style>